window.PaisagenVIP = window.PaisagenVIP || (function(){
  var MEMBERSHIP_VARIANT_ID = 45257423650998;
  var MEMBERSHIP_SELLING_PLAN_ID = 6541770934;
  var FREE_NECKLACE_VARIANT_ID = 45257424076982;
  var MEMBERSHIP_USD = 39.95;
  var NECKLACE_USD = 99;
  var SHIPPING_USD = 15;
  var FREE_SHIP_THRESHOLD_USD = 150;
  var state = { inCart: false, cart: null, fetching: false, lastFetch: 0 };
  var listeners = [];
  var AMBIGUOUS = ['AUD','CAD','SGD','HKD','NZD','TWD','MXN','CLP','COP','ARS'];

  function getRate(){ try{ return (window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate)) || 1; }catch(e){ return 1; } }
  function getActiveCurrency(){ try{ return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'; }catch(e){ return 'USD'; } }

  function convertAndFormat(usd){
    try{
      var rate=getRate(), currency=getActiveCurrency(), converted=usd*rate;
      var noDec=['JPY','KRW','VND','IDR','CLP','HUF','TWD'];
      var dec = noDec.indexOf(currency)===-1?2:0;
      var syms={'USD':'$','GBP':'£','EUR':'€','CAD':'CA$','AUD':'A$','NZD':'NZ$','BRL':'R$'};
      var sym = syms[currency]||(currency+' ');
      var f = dec===0? sym+Math.round(converted).toLocaleString() : sym+converted.toFixed(dec).replace(/\B(?=(\d{3})+(?!\d))/g,',');
      if(AMBIGUOUS.indexOf(currency)!==-1) f+=' '+currency;
      return f;
    }catch(e){ return '$'+usd; }
  }

  function fmtCents(cents, moneyFormat){
    try { if(window.Shopify && typeof window.Shopify.formatMoney === 'function') return window.Shopify.formatMoney(cents, moneyFormat); } catch(e){}
    return '$' + (cents/100).toFixed(2);
  }

  function fmtDecimal(amount, currency){
    try { return new Intl.NumberFormat(undefined,{style:'currency',currency:currency||'USD'}).format(parseFloat(amount)||0); }
    catch(e){ return '$'+(parseFloat(amount)||0).toFixed(2); }
  }

  function escapeHtml(str){
    return String(str).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; });
  }

  function parseJsonAttr(el, attr){
    try { return JSON.parse(el.getAttribute(attr)); } catch(e){ return null; }
  }

  function isoToFlagEmoji(iso){
    if (!iso || iso.length !== 2) return '🌍';
    iso = iso.toUpperCase();
    var A = 0x1F1E6;
    try {
      return String.fromCodePoint(
        iso.charCodeAt(0) - 65 + A,
        iso.charCodeAt(1) - 65 + A
      );
    } catch(e){ return '🌍'; }
  }

  function fillFlags(root){
    (root || document).querySelectorAll('.pg-flag[data-iso]').forEach(function(el){
      if (el.dataset.pgFlagDone) return;
      var iso = (el.getAttribute('data-iso') || '').toUpperCase();
      el.textContent = isoToFlagEmoji(iso);
      el.dataset.pgFlagDone = 'true';
    });
  }

  function initFlagAutoFill(){
    fillFlags();
    if (window.MutationObserver) {
      var scheduled = false;
      var observer = new MutationObserver(function(){
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function(){ scheduled = false; fillFlags(); });
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'complete' || document.readyState === 'interactive') initFlagAutoFill();
  else document.addEventListener('DOMContentLoaded', initFlagAutoFill, { once: true });

  function updateNativeCartBubble(itemCount){
    try {
      var bubble = document.querySelector('cart-icon [ref="cartBubble"]');
      var countEl = document.querySelector('cart-icon [ref="cartBubbleCount"]');
      if (!countEl) return;
      var hasItems = itemCount > 0;
      countEl.textContent = itemCount < 100 ? String(itemCount) : '';
      countEl.classList.toggle('hidden', !hasItems);
      if (bubble) bubble.classList.toggle('visually-hidden', !hasItems);
      var cartIconEl = document.querySelector('cart-icon');
      if (cartIconEl) cartIconEl.classList.toggle('header-actions__cart-icon--has-cart', hasItems);
      try {
        sessionStorage.setItem('cart-count', JSON.stringify({ value: String(itemCount), timestamp: Date.now() }));
      } catch(e){}
    } catch(e){}
  }

  function notify(){
    listeners.forEach(function(fn){ try{ fn(state); }catch(e){} });
    if (state.cart && typeof state.cart.item_count === 'number') {
      updateNativeCartBubble(state.cart.item_count);
    }
    document.dispatchEvent(new CustomEvent('paisagen:vip:sync', { detail: state, bubbles: true }));
  }

  function fetchCart(force){
    var now = Date.now();
    if (state.fetching) return Promise.resolve(state);
    if (!force && now - state.lastFetch < 300) return Promise.resolve(state);
    state.fetching = true;
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function(r){ return r.json(); })
      .then(function(c){
        state.cart = c;
        state.inCart = (c.items || []).some(function(i){ return i.variant_id == MEMBERSHIP_VARIANT_ID; });
        state.lastFetch = Date.now();
        state.fetching = false;
        notify();
        return state;
      })
      .catch(function(){ state.fetching = false; return state; });
  }

  function peekCart(){
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function(r){ return r.json(); });
  }

  function addSeq(items){
    var chain = Promise.resolve();
    items.forEach(function(item){
      chain = chain.then(function(){
        return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[item]})})
          .then(function(r){ return r.json().then(function(d){ if(!r.ok) throw new Error(d.description||d.message||'Add failed'); return d; }); });
      });
    });
    return chain;
  }

  var turnOnInFlight = false;
  var turnOffInFlight = false;

  function turnOn(extraVariantId){
    if (turnOnInFlight) return Promise.resolve(state);
    turnOnInFlight = true;
    state.inCart = true;
    notify();
    return peekCart().then(function(cartData){
      var hasMembership = (cartData.items||[]).some(function(i){ return i.variant_id==MEMBERSHIP_VARIANT_ID; });
      var hasNecklace   = (cartData.items||[]).some(function(i){ return i.variant_id==FREE_NECKLACE_VARIANT_ID; });
      var items = [];
      if (!hasMembership) items.push({ id: MEMBERSHIP_VARIANT_ID, quantity: 1, selling_plan: MEMBERSHIP_SELLING_PLAN_ID });
      if (!hasNecklace)   items.push({ id: FREE_NECKLACE_VARIANT_ID, quantity: 1 });
      if (extraVariantId) items.push({ id: Number(extraVariantId), quantity: 1 });
      if (!items.length) return fetchCart(true);
      return addSeq(items).then(function(){ return fetchCart(true); });
    }).catch(function(err){
      state.inCart = false;
      notify();
      throw err;
    }).finally(function(){ turnOnInFlight = false; });
  }

  function turnOff(){
    if (turnOffInFlight) return Promise.resolve(state);
    turnOffInFlight = true;
    state.inCart = false;
    notify();
    return peekCart().then(function(cartData){
      var items = cartData.items || [];
      var lines = [];
      items.forEach(function(i, idx){
        if (i.variant_id == MEMBERSHIP_VARIANT_ID || i.variant_id == FREE_NECKLACE_VARIANT_ID) {
          lines.push(idx + 1);
        }
      });
      lines.sort(function(a, b){ return b - a; });
      var chain = Promise.resolve();
      lines.forEach(function(line){
        chain = chain.then(function(){
          return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:line,quantity:0})});
        });
      });
      return chain.then(function(){ return fetchCart(true); });
    }).catch(function(err){
      state.inCart = true;
      notify();
      throw err;
    }).finally(function(){ turnOffInFlight = false; });
  }

  function addStandard(variantId){
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:Number(variantId),quantity:1})})
      .then(function(r){ return r.json().then(function(d){ if(!r.ok) throw new Error(d.description||d.message||'Add failed'); return d; }); })
      .then(function(){ return fetchCart(true); });
  }

  function openCartDrawer(){
    if (typeof window.paisagenOpenCart === 'function') { window.paisagenOpenCart(); return; }
    var d = document.querySelector('cart-notification,cart-drawer,[data-cart-drawer]');
    if (d && typeof d.open === 'function') d.open();
  }

  document.addEventListener('cart:refresh', function(){ fetchCart(true); });
  document.addEventListener('cart:updated', function(){ fetchCart(true); });
  window.addEventListener('pageshow', function(){ fetchCart(true); });

  if (!window.__paisagenFetchWrapped) {
    window.__paisagenFetchWrapped = true;
    var _fetch = window.fetch;
    window.fetch = function(){
      var args = arguments;
      return _fetch.apply(this, args).then(function(response){
        try {
          var url = (args[0] && args[0].url) ? args[0].url : args[0];
          if (typeof url === 'string' && (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1) && response.ok) fetchCart(true);
        } catch(e){}
        return response;
      });
    };
  }

  fetchCart(true);

  function subscribe(fn){ listeners.push(fn); fn(state); }
  function getState(){ return state; }

  window.__PaisagenVIPCore = {
    subscribe: subscribe,
    getState: getState,
    fetchCart: fetchCart,
    turnOn: turnOn,
    turnOff: turnOff,
    addStandard: addStandard,
    openCartDrawer: openCartDrawer,
    convertAndFormat: convertAndFormat,
    fmtCents: fmtCents,
    fmtDecimal: fmtDecimal,
    escapeHtml: escapeHtml,
    parseJsonAttr: parseJsonAttr,
    isoToFlagEmoji: isoToFlagEmoji,
    MEMBERSHIP_VARIANT_ID: MEMBERSHIP_VARIANT_ID,
    MEMBERSHIP_SELLING_PLAN_ID: MEMBERSHIP_SELLING_PLAN_ID,
    FREE_NECKLACE_VARIANT_ID: FREE_NECKLACE_VARIANT_ID,
    MEMBERSHIP_USD: MEMBERSHIP_USD,
    NECKLACE_USD: NECKLACE_USD,
    SHIPPING_USD: SHIPPING_USD,
    FREE_SHIP_THRESHOLD_USD: FREE_SHIP_THRESHOLD_USD
  };

  return window.__PaisagenVIPCore;
})();
